




import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import QueryPagination from "@/components/QueryPagination.vue";
Vue.component("QueryPagination", QueryPagination);

@Component({
  name: "UserListPager",
})
export default class UserListPager extends Vue {
  @Prop({ type: Number, required: true })
  public readonly totalPages!: number;
}
